import React from 'react';
import { Icon, DivIcon } from 'leaflet';
import { IoLocationSharp } from 'react-icons/io5';
import { Buffer } from 'buffer';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { customMarkerIcon } from '../util/MapHelpers';

const useMapMarker = ({ color }: { color?: string }) => {
  const { theme } = useSelector((data: RootState) => data.config.config);
  const { primary: primaryColor } = theme;

  // Create a function to generate the icon with dynamic color
  const LocationIcon = `
    <svg
      fill="${primaryColor || '#ff4d4f'}"
      height="32px"
      width="32px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 20.48 20.48"
      enable-background="new 0 0 512 512"
      xml:space="preserve"
    >
      <path
        d="M10.24 0C5.972 0 2.56 3.412 2.56 7.68c0 1.476 0.44 2.616 1.204 3.772l5.668 8.6c0.172 0.26 0.468 0.428 0.808 0.428s0.64 -0.172 0.808 -0.428l5.668 -8.6C17.48 10.296 17.92 9.156 17.92 7.68 17.92 3.412 14.508 0 10.24 0m0 11.944c-2.356 0 -4.268 -1.912 -4.268 -4.272S7.884 3.4 10.24 3.4s4.268 1.912 4.268 4.272S12.596 11.944 10.24 11.944"
      />
    </svg>
`;

  // Custom hotel pin icon
  const defaultHotelIcon = new Icon({
    iconUrl:
      'data:image/svg+xml;base64,' +
      // btoa(LocationIcon),
      Buffer.from(LocationIcon, 'utf-8').toString('base64'),
    // iconUrl: <IoLocationSharp /> ,
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
  });

  const hotelIcon = color ? customMarkerIcon(color) : defaultHotelIcon;

  // Custom cluster icon
  const createClusterIcon = (count: number) =>
    new DivIcon({
      html: `
    <div class="map-cluster-marker">
      <div class="map-cluster-inner">
        ${count}
      </div>
    </div>
  `,
      className: 'map-cluster-wrapper',
      iconSize: [40, 40],
      iconAnchor: [20, 40],
    });

  return {
    hotelIcon,
    createClusterIcon,
  };
};

export default useMapMarker;
